module.exports = __webpack_public_path__ + "static/img/cardNumProcessos.c43e6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardNumProcessos.png
// module id = fQL7
// module chunks = 11